module.exports = " <div class=aboutview> <div class=nav> <span v-for=\"item of items\" :class=\"{'active': tabIndex===$index}\" @click=tab($index)>{{item.title}}</span> </div> <div class=nav-content v-html=article></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.5.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/about.vue
// module id = 26
// module chunks = 2